export default {
  AutocompleteVacationDestinations__CLOSE_ARIA_LABEL: "Select to close",
  AutocompleteVacationDestinations__SEARCH_CAPTION:
    "Please enter 3 characters to find a destination",
};
